export default __webpack_public_path__ + "static/media/Poppins-LightItalic.4a7d59f8.ttf";